import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reservation-highlight"
export default class extends Controller {
  static targets = ["card", "backdrop"]
  static values = {
    duration: { type: Number, default: 3000 }, // 3초 동안 하이라이트
    autoHighlight: { type: Boolean, default: false }
  }

  connect() {
    // 새로 생성된 예약인 경우 자동 하이라이트
    if (this.autoHighlightValue) {
      this.highlight()
    }
  }

  highlight() {
    // 이미 하이라이트 중이면 무시
    if (this.isHighlighted) {
      return
    }

    this.isHighlighted = true

    // 배경 오버레이 생성
    this.createBackdrop()

    // 카드에 하이라이트 클래스 추가
    this.cardTarget.classList.add('reservation-highlighted')
    this.cardTarget.style.zIndex = '1000'

    // 지정된 시간 후 하이라이트 제거
    this.highlightTimeout = setTimeout(() => {
      this.removeHighlight()
    }, this.durationValue)
  }

  removeHighlight() {
    if (!this.isHighlighted) {
      return
    }

    this.isHighlighted = false

    // 배경 오버레이 제거
    this.removeBackdrop()

    // 카드 하이라이트 클래스 제거
    this.cardTarget.classList.remove('reservation-highlighted')
    this.cardTarget.style.zIndex = ''

    // 타임아웃 정리
    if (this.highlightTimeout) {
      clearTimeout(this.highlightTimeout)
      this.highlightTimeout = null
    }
  }

  createBackdrop() {
    // 백드롭이 이미 존재하면 재사용
    if (this.backdropElement) {
      this.backdropElement.classList.add('active')
      return
    }

    // 백드롭 생성
    this.backdropElement = document.createElement('div')
    this.backdropElement.className = 'reservation-backdrop'
    this.backdropElement.addEventListener('click', () => this.removeHighlight())

    // DOM에 추가
    document.body.appendChild(this.backdropElement)

    // 애니메이션을 위한 강제 리플로우
    this.backdropElement.offsetHeight

    // active 클래스 추가 (fade-in 애니메이션)
    this.backdropElement.classList.add('active')
  }

  removeBackdrop() {
    if (!this.backdropElement) {
      return
    }

    // fade-out 애니메이션
    this.backdropElement.classList.remove('active')

    // 애니메이션 완료 후 DOM에서 제거
    setTimeout(() => {
      if (this.backdropElement && this.backdropElement.parentNode) {
        this.backdropElement.parentNode.removeChild(this.backdropElement)
      }
      this.backdropElement = null
    }, 300) // CSS transition duration과 일치
  }

  disconnect() {
    // 컨트롤러 제거 시 정리
    this.removeHighlight()
  }

  // 수동 토글 (디버깅용)
  toggle() {
    if (this.isHighlighted) {
      this.removeHighlight()
    } else {
      this.highlight()
    }
  }
}
